import { Loader } from "@zfp-akademie-a-s/zfp-design";

import { useUserContext } from "Infrastructure/Context/UserContext";
import { ErrorAppAccessPage } from "Infrastructure/Pages/ErrorAppAccessPage";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export const PermissionAppAccessGuard = ({ children }: Props) => {
  const { hasAllPermissions, loading } = useUserContext();

  if (loading) return <Loader />;

  const hasAccess = hasAllPermissions(["app_access"]);

  if (!hasAccess) {
    return <ErrorAppAccessPage />;
  }

  return <>{children}</>;
};
